import { render, staticRenderFns } from "./CompressionSettingsModal.vue?vue&type=template&id=20d025d7&scoped=true"
import script from "./CompressionSettingsModal.vue?vue&type=script&lang=js"
export * from "./CompressionSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./CompressionSettingsModal.vue?vue&type=style&index=0&id=20d025d7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d025d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d025d7')) {
      api.createRecord('20d025d7', component.options)
    } else {
      api.reload('20d025d7', component.options)
    }
    module.hot.accept("./CompressionSettingsModal.vue?vue&type=template&id=20d025d7&scoped=true", function () {
      api.rerender('20d025d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/CompressionSettingsModal.vue"
export default component.exports